<template>
  <div>
    <div class="base wape">
      <div class="main">
        <a-row class="mide" type="flex" style="height: 44px" align="middle">
          <a-col class="made" :span="8">
            <a-button
              class="local-bth"
              style="margin-top: 8px"
              @click="goChangeCity"
            >
              <span>{{ region }}</span>
              <a-icon
                type="caret-right"
                width="3px;"
                height="3px;"
                style="position: relative; top: 4px; margin-left: 2px"
                :rotate="45"
              />
            </a-button>
          </a-col>
          <a-col class="mbde" :span="8" align="center">
            <img
              width="90px;height: 24px;"
              src="@/assets/complete-logo.png"
              alt=""
            />
          </a-col>
        </a-row>
      </div>
      <div class="top-banner">
        <!-- autoplay -->
        <a-carousel autoplay>
          <div class="banner banner1">
            <div class="banner-info">
              <div class="banner-main-title">
                <img
                  style="margin: auto"
                  src="@/assets/index/组16@3x.png"
                  height="40px"
                  alt=""
                />
              </div>
              <!-- <div class="banner-vice-title">就近安排   专业可靠</div> -->
              <a-button class="banner-btn" shape="round" @click="goCourse">
                立即找家教
              </a-button>
            </div>
          </div>
          <div class="banner banner2" @click="goPromote">
            <div class="banner-info">
              <div class="banner-main-title">
                <img style="margin: auto" src="" height="40px" alt="" />
              </div>
              <!-- <div class="banner-vice-title">就近安排   专业可靠</div> -->
              <!-- <a-button class="banner-btn" shape="round" >去看看</a-button> -->
            </div>
          </div>
        </a-carousel>
      </div>
      <!-- 菜单栏目 -->
      <div class="main-menu">
        <a-row type="flex" justify="space-between">
          <a-col :span="4">
            <div class="item-area">
              <div class="icon-area" @click="goCourse">
                <img src="@/assets/index/选课@2x.png" alt="" />
              </div>
              <div class="item-title">选课</div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="item-area" style="margin: auto">
              <div class="icon-area" @click="goTeacher">
                <img src="@/assets/index/教员@2x.png" alt="" />
              </div>
              <div class="item-title">教员</div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="item-area" style="margin: auto">
              <div class="icon-area" @click="goForum()">
                <img src="@/assets/index/论坛@2x.png" alt="" />
              </div>
              <div class="item-title">论坛</div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="item-area" style="float: right">
              <div class="icon-area" @click="goMyCenter">
                <img src="@/assets/index/我的@2x.png" alt="" />
              </div>
              <div class="item-title">我的</div>
            </div>
          </a-col>
        </a-row>
      </div>
      <van-swipe
        v-if="today_arrange.length > 0"
        class="my-swipe"
        indicator-color="white"
      >
        <van-swipe-item v-for="(arrange, index) in today_arrange" :key="index">
          <div class="tomorrow">
            <div class="course-first">
              <div class="left">今日课程</div>
              <button class="right"><van-icon name="share" />导航</button>
            </div>
            <div class="course-second">
              <div class="curriculum">
                <img
                  src="@/assets/test-header.png"
                  alt=""
                  style="width: 60px"
                />
              </div>
              <div class="curriculum-first">
                <div class="course-third">
                  <span>{{ arrange.student_nick_name }}</span>
                  <span>{{ arrange.student_stage }}</span>
                </div>
                <div>
                  <span
                    >{{ arrange.student_teaching_subject }}-{{
                      arrange.service_pack_title
                    }}</span
                  >
                </div>
              </div>
              <div class="curriculum-second" style="">
                <div>{{ arrange.teaching_day }}</div>
                <div style="">
                  {{ arrange.teaching_time }}
                </div>
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>

      <!-- 热门 -->
      <div class="hot-area">
        <div class="university">
          <a-row class="over">
            <a-col class="orange-color" :span="1">
              <div style="" />
            </a-col>
            <a-col class="orange-area" :span="5">
              <div style="">热门学校</div>
            </a-col>
            <a-col class="technikon" :span="18">
              <div class="university-list-name">
                <span
                  v-for="(univercity, index) in hot_university.slice(0, 5)"
                  :key="index"
                  @click="schoolChange(univercity.name)"
                  >{{ univercity.name }}</span
                >
                <!-- <span>重庆理工大学</span>
                            <span>重庆理工大学</span>
                            <span>重庆理工大学</span>
                            <span>重庆理工大学</span> -->
              </div>
            </a-col>
          </a-row>
        </div>
        <div class="course" style="">
          <a-row class="over-second" style="">
            <a-col class="blue-color" :span="1">
              <div style="" />
            </a-col>
            <a-col class="blue-area" :span="5" style="">
              <div style="">
                <span>热门课程</span>
              </div>
            </a-col>
            <a-col :span="18">
              <div class="university-list-name">
                <span
                  v-for="(course, index) in hot_subjects.slice(0, 4)"
                  :key="index"
                  >{{ course }}</span
                >
                <!-- <span>小学一年级数学</span>
                            <span>小学六年级英语</span>
                            <span>初中一二年级物理</span>
                            <span>高中一二年级语文</span> -->
              </div>
            </a-col>
          </a-row>
        </div>
        <div class="area" style="">
          <a-row class="door-area" style="">
            <a-col class="doom" :span="1">
              <div style="" />
            </a-col>
            <a-col class="doom-area" :span="5" style="">
              <div style="">
                <span style="">热门地区</span>
              </div>
            </a-col>
            <a-col :span="18">
              <div class="university-list-name">
                <span
                  v-for="(area, index) in hot_area.slice(0, 5)"
                  :key="index"
                  >{{ area.name }}</span
                >
                <!-- <span>渝北</span>
                            <span>江北</span>
                            <span>渝中</span>
                            <span>九龙坡</span>
                            <span>巴南</span>
                            <span>南岸</span> -->
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <div v-if="new_announce.length > 0" class="normal" style="">
        <a-row class="notice" :gutter="8" style="">
          <a-col class="normal-left" :span="6">
            <div class="notice-first">
              <van-icon name="volume" />
              <span>公告</span>
            </div>
          </a-col>
          <a-col class="normal-right" :span="18">
            <span
              v-for="(announce, index) in new_announce.slice(0, 1)"
              :key="index"
              >{{ announce.title }}</span
            >
          </a-col>
        </a-row>
      </div>
    </div>
    <!--在校教员 -->
    <div class="wape">
      <div class="teacher">
        <div class="tode" style="">
          <div class="online" style="" />
          <div class="apple" style="">在校教员</div>
          <div class="banana" style="" @click="goMore">更多</div>
        </div>
        <div v-if="part_time_teacher.length > 0" class="shaw">
          <a-row
            v-for="(teacher, index) in part_time_teacher"
            :key="index"
            :gutter="16"
            class="look"
            type="flex"
            style=""
          >
            <a-col :span="6" style="overflow: hidden; text-align: center">
              <div class="place" @click="goAhead(teacher.id)">
                <img :src="teacher.avatar" alt="" style="height: 60px" />
              </div>
              <div
                style="
                  font-size: 14px;
                  text-align: center;
                  overflow: hidden;
                  height: 16px;
                "
                @click="goAhead(teacher.id)"
              >
                {{ teacher.nick_name }}
              </div>
            </a-col>
            <a-col :span="18" align="left">
              <div style="font-weight: bolder">
                {{ teacher.school }}
              </div>
              <div>{{ teacher.self_evaluation.slice(0, 30) + '...' }}</div>
            </a-col>
          </a-row>
        </div>
        <van-empty v-else description="暂无数据" />
      </div>
      <!-- 专职教师 -->
      <div class="full-time">
        <div class="table" style="">
          <div class="online-first" style="" />
          <div class="pencil" style="">专职教师</div>
          <div class="pen" style="" @click="goMore">更多</div>
        </div>
        <div v-if="full_time_teacher.length > 0" class="box">
          <a-row
            v-for="(teacher, index) in full_time_teacher"
            :key="index"
            :gutter="16"
            class="cook"
            type="flex"
            style=""
          >
            <a-col :span="6" style="text-align: center">
              <div class="replace" @click="goAhead(teacher.id)">
                <img :src="teacher.avatar" alt="" style="height: 60px" />
              </div>
              <div style="font-size: 14px" @click="goAhead(teacher.id)">
                {{ teacher.nick_name }}
              </div>
            </a-col>
            <a-col :span="18" align="left">
              <div style="font-weight: bolder">
                {{ teacher.school }}
              </div>
              <div>{{ teacher.self_evaluation.slice(0, 30) + '...' }}</div>
            </a-col>
          </a-row>
        </div>
        <van-empty v-else description="暂无数据" />
      </div>
      <!-- 教员流程 -->
      <div class="instructor" style="">
        <div class="process" style="">
          <div class="online-second" style="" />
          <div class="panner" style="">教员流程</div>
        </div>
        <div class="faculty-text" style="">
          <a-row :gutter="8">
            <a-col class="" :span="12" style="">
              <div class="above step-item">
                <div class="content" style="">
                  <span style="">1</span>
                </div>
                <div class="chart" style="">
                  <img
                    src="@/assets/teacher-process1.png"
                    alt=""
                    width="29px"
                    height="29px"
                  />
                </div>
                <div class="realname" style="">
                  <span>实名认证</span>
                </div>
                <div class="alipy" style="">
                  使用支付宝人脸识别功能完成对教员真实
                </div>
              </div>
            </a-col>
            <a-col class="" :span="12" style="">
              <div class="below step-item">
                <div class="information" style="">
                  <span style="">2</span>
                </div>
                <div class="chart" style="">
                  <img
                    src="@/assets/audit-information.png"
                    alt=""
                    width="32px"
                    height="32px"
                  />
                </div>
                <div class="realname" style="">
                  <span>信息审核</span>
                </div>
                <div class="alipy" style="">
                  填写基本信息及授课范围，证书荣誉
                </div>
              </div>
            </a-col>
          </a-row>
          <a-row :gutter="8" style="margin-top: 15px">
            <a-col class="" :span="12" style="">
              <div class="reason step-item">
                <div class="oneself" style="">
                  <span style="">3</span>
                </div>
                <div class="chart" style="">
                  <img
                    src="@/assets/publishing-service.png"
                    alt=""
                    width="32px"
                    height="32px"
                  />
                </div>
                <div class="realname" style="">
                  <span>发布服务</span>
                </div>
                <div class="alipy" style="">根据自身时间安排发布服务包</div>
              </div>
            </a-col>
            <a-col class="" :span="12" style="">
              <div class="service-first step-item">
                <div class="indent" style="">
                  <span style="">4</span>
                </div>
                <div class="chart" style="">
                  <img
                    src="@/assets/door-teach.png"
                    alt=""
                    width="32px"
                    height="32px"
                  />
                </div>
                <div class="realname" style="">
                  <span>上门授课</span>
                </div>
                <div class="alipy" style="">根据订单时间安排及时上门授课</div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <!-- 家长流程 -->
      <div class="mission" style="">
        <div class="earnest" style="">
          <div class="study" style="" />
          <div class="curriculum" style="">家长流程</div>
        </div>
        <div class="citizen" style="">
          <a-row :gutter="8">
            <a-col :span="12" style="">
              <div class="employ step-item">
                <div class="pay" style="">
                  <span style="">1</span>
                </div>
                <div class="chart" style="">
                  <img
                    src="@/assets/teacher-process1.png"
                    alt=""
                    width="29px"
                    height="29px"
                  />
                </div>
                <div class="realname" style="">
                  <span style="">实名认证</span>
                </div>
                <div class="alipy" style="">
                  使用支付宝人脸识别功能完成对教员真实身份
                </div>
              </div>
            </a-col>
            <a-col :span="12" style="">
              <div class="employ-first step-item">
                <div class="add" style="">
                  <span style="">2</span>
                </div>
                <div class="chart" style="">
                  <img
                    src="@/assets/add-student.png"
                    alt=""
                    width="32px"
                    height="32px"
                  />
                </div>
                <div class="realname" style="">
                  <span style="">添加学员</span>
                </div>
                <div class="alipy" style="">添加孩子学习阶段及学习情况</div>
              </div>
            </a-col>
          </a-row>
          <a-row :gutter="8" style="margin-top: 15px">
            <a-col class="employ-second" :span="12">
              <div class="purchase step-item" style="">
                <div class="buy" style="">
                  <span style="">3</span>
                </div>
                <div class="chart" style="">
                  <img
                    src="@/assets/serve.png"
                    alt=""
                    width="32px"
                    height="32px"
                  />
                </div>
                <div class="realname" style="">
                  <span style="">购买服务</span>
                </div>
                <div class="alipy" style="">
                  根据所在地址匹配提供服务的教员，自主下单
                </div>
              </div>
            </a-col>
            <a-col class="employ-third" :span="12">
              <div class="wait step-item" style="">
                <div class="teach-first" style="">
                  <span style="">4</span>
                </div>
                <div class="chart" style="">
                  <img
                    src="@/assets/door-teach.png"
                    alt=""
                    width="32px"
                    height="32px"
                  />
                </div>
                <div class="realname" style="">
                  <span style="">上门授课</span>
                </div>
                <div class="alipy" style="">
                  等待教员上门授课，根据授课情况进行评价
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="forum" style="">
        <div class="how" style="">
          <div class="how-first" style="" />
          <div class="how-second" style="">家教论坛</div>
        </div>
        <div class="content-area" style="margin-top: 10px">
          <a-tabs>
            <a-tab-pane key="1" tab="最热">
              <div
                v-for="(item, index) in hot_posts"
                :key="index"
                class="item"
                style=""
                @click="goForumInfo(item.id)"
              >
                <span>{{ item.title }}...</span>
                <span style="float: right">{{
                  item.create_time | dayFormat
                }}</span>
              </div>
            </a-tab-pane>
            <a-tab-pane key="2" tab="最新">
              <div
                v-for="(item, index) in lastest_posts"
                :key="index"
                class="item"
                style=""
                @click="goForumInfo(item.id)"
              >
                <span>{{ item.title }}...</span>
                <span style="float: right">{{
                  item.create_time | dayFormat
                }}</span>
              </div>
            </a-tab-pane>
            <!-- 右边跳转符号哦 -->
            <a-button
              slot="tabBarExtraContent"
              style="float: right"
              type="link"
              @click="goForum()"
            >
              <a-icon type="right" />
            </a-button>
          </a-tabs>
        </div>
      </div>
      <main-footer />
    </div>
  </div>
</template>

<script>
import { mapLoader } from '@/utils/util'
import { mapActions } from 'vuex'
import { MainFooter } from '@/components'

const data = [
  {
    title: 'Title 1'
  },
  {
    title: 'Title 2'
  },
  {
    title: 'Title 3'
  },
  {
    title: 'Title 4'
  }
]

export default {
  name: 'IndexPage',
  description: '首页',
  components: {
    MainFooter
  },
  data() {
    return {
      data,
      region: '',
      hot_area: [],
      hot_subjects: [],
      hot_university: [],
      // 全职教师
      full_time_teacher: {},
      // 在校教员
      part_time_teacher: {},
      forum: {},
      hot_posts: [],
      lastest_posts: [],
      new_news: [],
      new_announce: [],
      today_arrange: []
    }
  },
  computed: {
    localRegion() {
      return this.$store.getters.region
    },
    accountType() {
      return this.$store.getters.accountType
    }
  },
  mounted() {
    // 判断当前未设置位置,调用浏览器位置
    if (this.localRegion === null) {
      mapLoader((data) => {
        //  未获取到
        if (data.type === 'error') {
          this.lookMap('重庆市')
        } else {
          if (data.addressComponent.city !== undefined) {
            this.lookMap(data.addressComponent.city)
          }
        }
      })
    }

    this.region = this.localRegion
    this.loadData(this.localRegion)
  },
  methods: {
    ...mapActions(['SetRegion']),
    lookMap(city) {
      const { SetRegion } = this
      SetRegion(city).then(() => {
        this.region = city
        this.loadData(city)
      })
    },
    loadData(region) {
      this.$http({
        url: '/index/index/index',
        method: 'get',
        params: {
          region: region
        }
      }).then((res) => {
        if (res.status === 'success') {
          var data = res.data
          this.hot_university = data.region_info.hot_university
          this.hot_subjects = data.region_info.hot_subjects
          this.hot_area = data.region_info.hot_area
          // 在校教员
          this.part_time_teacher = data.part_time_teacher.data
          // 专职教师
          this.full_time_teacher = data.full_time_teacher.data
          // 家教论坛(最热)
          this.hot_posts = data.forum.hot_posts
          // 家教论坛(最新)
          this.lastest_posts = data.forum.latest_posts
          // 公告数据
          this.new_announce = data.new_announce
          console.log(data.new_announce)

          // 教员授课数据，如果当前教员登录并且今日存在授课
          this.today_arrange = data.today_arrange
        } else {
          this.$notification.error({
            message: '错误',
            description: '获取数据失败'
          })
        }
      })
    },
    goPromote() {
      this.$router.push({ name: 'Promote' })
    },
    goCourse() {
      this.$router.push({ name: 'TutorList' })
    },
    goTeacher() {
      this.$router.push({ name: 'RevealList' })
      this.$router.push({ name: 'RevealList', params: { id: 32332 } })
    },
    goForum() {
      this.$router.push({ name: 'ForumList' })
    },
    goMyCenter() {
      if (this.accountType === 'teacher') {
        this.$router.push({ name: 'TeacherIndex' })
      } else {
        this.$router.push({ name: 'UserIndex' })
      }
    },
    goMore() {
      this.$router.push({ name: 'RevealList' })
    },
    goAhead(TeacherId) {
      this.$router.push({ name: 'RevealInfo', params: { id: TeacherId } })
    },
    goForumInfo(forumId) {
      this.$router.push({ name: 'ForumInfo', params: { id: forumId } })
    },
    goChangeCity() {
      this.$router.push({ name: 'ChangeCity' })
    },
    schoolChange(value) {
      this.$router.push({ name: 'RevealList', query: { school: value } })
    }
  }
}
</script>
<style lang="stylus" scoped>
.top-banner {
  position relative;

  .ant-carousel >>> .slick-slide {
    text-align: center;
    max-height: 580px;
    // background: $theme-color;
    overflow: hidden;
  }

  .ant-carousel {
    .banner {
      width: 100%;
      height: 120px;
      background-size: cover;
      position relative
      overflow: hidden;
      border-radius: 10px;
    }

    .banner1 {
      background: url('../assets/index/banner/banner_bg@2x.png') no-repeat;
    }

    .banner2  {
      background: url('../assets/index/banner/banner_bg_two.jpg') no-repeat;
      background-size: cover;
    }

    .banner-info {
      margin: auto;
      height: 78px;
      text-align: center;

      .banner-main-title {
        font-family: STHupo;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;

        margin-top: 24px;
      }

      .banner-vice-title {
        font-family: MicrosoftYaHei;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
      }

      .banner-btn {
        height: 25px;
        background-color: #ffffff;
        border-radius: 13px;
        margin-top: 13px;
        color: $theme-color;
        font-size: 5px;
        color: #ff5c00;
      }
    }
  }
}

.main-menu {
    // height: 72px;
    width: 100%;
    padding: 4px 8px;
    overflow: hidden;

    .item-area {
        width: 46px;
        text-align: center;

        .icon-area {
            width: 100%;

            img {
                width: 46px;
                height: 46px;
            }
        }

        .item-title {
            font-family: PingFang-SC-Medium;
            font-size: 12px;
            line-height: 21px;
            color: #333333;
            margin-top: 10px;
        }
    }
}

.tomorrow{
    margin-top:20px;
    padding:15px;
    border:1px dashed #fa750d;
    border-radius:10px;
    .course-first{
        overflow:hidden;
        .left{
            float:left;
        }
        .right{
            float:right;
            border-radius:12px;
            font-size:11px;
            border:none;
            background-color:#fa750d;
            color:#ffffff;
            width:49px;
            height:24px;
        }
    }
    .course-second{
        overflow:hidden;
        margin-top:23px;
        .curriculum{
            float:left;
        }
        .curriculum-first{
            float:left;
            margin-left:14px;
            margin-top:9px;
            .course-third span:first-child {
                font-size:18px;
                color:#333333;
                font-family: PingFang-SC-Bold;
                font-weight:bold;
            }span:nth-child(2){
                    margin-left:8px;
                }
        }
        .curriculum-second{
            float:right;
            margin-top:9px;
            div:nth-child(2){
                font-size:24px;
                color:#333333;
                font-weight:bold;
            }
        }
    }
}

.hot-area {
    .university-list-name {
        padding: 10px;

        span {
            margin-right: 10px;
            line-height: 26px;
        }
    }
}

.hot-school-area {
    height: 70px;
    background-color: #ffffff;
    border-radius: 5px;
}

.wape{
    max-width:420px;
    min-width:280px;
    padding:0 15px;
    margin:auto;
    background-color: #fff;
    .course{
        margin-top:17px;
        border-radius:10px;
        overflow:hidden;
        box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
    }
    .course .over-second{
        height:70px;
    }
    .course .over-second .blue-color div{
        background-color: #4b70fd;
        height:70px;
    }
    .course .blue-area{
        position: relative;left: -7px;
    }
    .course .blue-area div{
        text-align:center;
        background: url('../assets/index/课程@2x.png') no-repeat;
        line-height:70px;
        color:#4b70fd;
    }
    .main .mide .made{
        text-align: left;

        .local-bth {
            // width: 50px;
            height: 22px;
            background-color: #f0f0f0;
            border-radius: 5px;
            font-size: 12px;
            padding: 2px 10px 2px 10px;
        }
    }
    .main .mide .mbde{
        height:20px;
        text-align: center;
    }
    .main .mide .mcde{
        height 20px;
        text-align: right;
    }
    .area{
        margin-top:17px;
        box-shadow:0 0 10px 0 rgba(216,216,216,0.3);
        overflow:hidden;
        border-radius:10px;
        .doom div{
            background-color: #5bc979;
            height:70px;
        }
        .doom-area{
            position: relative;
            left: -7px;
            div{
                background: url('../assets/index/地区@2x.png') no-repeat;
                line-height:70px;
                text-align:center;
            }
    }
        .doom-area span{
            color:#5bc979;
        }
    }
    .teacher .tode{
        overflow:hidden;
        margin-top:41px;
        .online{
           float:left;
           width:6px;
           height:20px;
           background-color:#fa750d;
           border-radius:3px;
        }
        .apple{
            float:left;
            margin-left:9px;
            line-height:20px;
            font-size:21px;
        }
        .banana{
            float:right;
            padding-right:15px;
            line-height:16px;
            font-size:14px;
        }
    }
    .teacher .shaw .look{
        height:108px;
        box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
        margin-top:24px;
        padding:19px 17px 12px 15px;
        .place img{
            width:60px;
            height:60px;
            border-radius:50%;
        }
    }
    .teacher .shaw .book{
        height:108px;
        box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
        margin-top:15px;
        padding:19px 17px 12px 15px;
        .cook{
            font-size:14px;
            text-align:center;
        }
    }
    .full-time .table{
        overflow:hidden;
        margin-top:37px;
        .online-first{
            float:left;
            width:6px;
            height:20px;
            background-color:#fa750d;
            border-radius:3px;
        }
        .pencil{
            float:left;
            margin-left:10px;
            font-size:21px;
            line-height:20px;
        }
        .pen{
            float:right;
            padding-right:15px;
            line-height:16px;
            font-size:14px;
        }
    }

    .full-time .box .cook{
        height:108px;
        box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
        margin-top:24px;
        padding:19px 17px 12px 15px;
        .replace img{
            width:60px;
            height:60px;
            border-radius:50%;
        }
    }
    .full-time .box .ponyo{
        height:108px;
        box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
        margin-top:15px;
        padding:19px 17px 12px 15px;
    }
    .instructor{
        margin-top:40px;
        .process{
            overflow:hidden;
            .online-second{
                float:left;
                width:6px;
                height:20px;
                background-color:#fa750d;
                border-radius:3px;
            }
            .panner{
                float:left;
                margin-left:9px;
                font-size:21px;
                line-height:20px;
            }
        }
        .faculty-text{
            margin-top:24px;
            .above{
                overflow: hidden;
                position: relative;
                box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
                height: 140px;
                border-radius:10px;
                .content{
                    background-color:#fbd7cd;
                    width:51px;
                    height:51px;
                    border-radius:50%;
                    position:absolute;
                    left:-20px;
                    top:-20px;
                    span{
                        color:#fff;
                        position:relative;
                        left:30px;
                        top:25px;
                    }
                }
            }
            .below{
                overflow:hidden;
                position:relative;
                box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
                height:140px;
                border-radius:10px;
                .information{
                    background-color:#4b70fd;
                    width:51px;
                    height:51px;
                    border-radius:50%;
                    position:absolute;
                    left:-20px;
                    top:-20px;
                    span{
                        color:#fff;
                        position:relative;
                        left:30px;
                        top:25px;
                    }
                }
            }
            .reason{
                overflow:hidden;
                position:relative;
                box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
                height:140px;
                border-radius:10px;
                .oneself{
                    background-color:#eda52a;
                    width:51px;
                    height:51px;
                    border-radius:50%;
                    position:absolute;
                    top:-20px;
                    left:-20px;
                    span{
                        color:#fff;
                        position:relative;
                        left:30px;
                        top:25px;
                    }
                }
            }
            .service-first{
               overflow:hidden;
               height:140px;
               box-shadow:0 0 10px 0 rgba(216,216,216,0.3);
               height:140px;
               position:relative;
               border-radius:10px;
               .indent{
                    background-color:#5bc974;
                    width:51px;
                    height:51px;
                    position:absolute;
                    top:-20px;
                    left:-20px;
                    border-radius:50%;
                    span{
                        color:#fff;
                        position:relative;
                        left:30px;
                        top:25px;
                    }
                }
            }
        }
    }
    .mission{
        margin-top:40px;
        .earnest{
            overflow:hidden;
            .study{
                float:left;
                width:6px;
                height:18px;
                background-color:#fa750d;
                border-radius:3px;
            }
            .curriculum{
                float:left;
                margin-left:10px;
                font-size:21px;
                line-height:20px;
                color:#333333;
            }
        }
        .citizen{
            margin-top:21px;
            .employ{
                overflow:hidden;
                position:relative;
                box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
                height:140px;
                padding-right:10px;
                border-radius:10px;
                .pay{
                    background-color:#fbd7cd;
                    width:51px;
                    height:51px;
                    border-radius:50%;
                    position:absolute;
                    top:-20px;
                    left:-20px;
                    span{
                        color:#fff;
                        position:relative;
                        top:25px;
                        left:30px
                    }
                }
            }
            .employ-first{
                overflow:hidden;
                position:relative;
                box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
                height:140px;
                border-radius:10px;
                .add{
                    background-color:#4b70fd;
                    width:51px;
                    height:51px;
                    border-radius:50%;
                    position:absolute;
                    top:-20px;
                    left:-20px;
                    span{
                        color:#fff;
                        position:relative;
                        top:25px;
                        left:30px;
                    }
                }
            }
        }
        .employ-second .purchase{
            overflow:hidden;
            box-shadow:0 0 10px 0 rgba(216,216,216,0.3);
            height:140px;
            position:relative;
            border-radius:10px;
            .buy{
                background-color:#eda52a;
                width:51px;
                height:51px;
                border-radius:50%;
                position:absolute;
                left:-20px;
                top:-20px;
                span{
                    color:#fff;
                    position:relative;
                    left:30px;
                    top:25px;
                }
            }
        }
        .employ-third .wait{
            overflow:hidden;
            position:relative;
            box-shadow:0 0 10px 0 rgba(216,216,216,0.3);
            height:140px;
            border-radius:10px;
            .teach-first{
                background-color:#5bc974;
                width:51px;
                height:51px;
                border-radius:50%;
                position:absolute;
                top:-20px;
                left:-20px;
                span{
                    color:#ffffff;
                    position:relative;
                    left:30px;
                    top:25px;
                }
            }
        }
    }
    .forum{
        margin-top:40px;
        .how{
            overflow:hidden;
            .how-first{
                float:left;
                width:6px;
                height:18px;
                background-color:#fa750d;
                border-radius:3px;
            }
            .how-second{
                float:left;
                margin-left:10px;
                font-size:21px;
                line-height:20px;
                color:#333333;
            }
        }
        .content-area{
            margin-left:16px;
            // width:315px;
            margin-top:30px;
            border-bottom:1px solid #e9e9e9;
            .item {
                line-height: 32px;
                border-bottom: 1px solid  #e9e9e9;
                cursor: pointer;

                span:first-child {
                    font-family: PingFang-SC-Regular;
                    font-size: 14px;
                    line-height: 32px;
                    color: #333333;
                }

                span:nth-child(2) {
                    font-family: PingFang-SC-Regular;
                    font-size: 14px;
                    line-height: 32px;
                    color: #666666;
                }
            }
        }
    }
    .little-orange{
        text-align:center;
        margin-top:40px;
        font-size:11px;
        height:30px;
        color:#d2d2d2;
        span{
            line-height:30px;
        }
    }
}
.university .over{
    height:70px;
    margin-top:19px;
    box-shadow: 0 0 10px 0px rgba(216,216,216,0.3);
    border-radius:10px;
    overflow:hidden;
    .orange-color div {
        background-color:#fa750d;
        height:70px;
    }

    .orange-area{
        position: relative;
        left: -7px;
    }

    .orange-area div{
        text-align:center;
        background: url('../assets/index/学校@2x.png') no-repeat;
        line-height: 70px;
        color: #fa750d;
    }

    .technikon .university-list-name div{
        padding:15px 16px 0 16px;
        text-align:left;

        span {
            line-height: 26px;
        }
    }
}

.step-item {
    .chart {
        text-align: center;
        margin-top: 20px;
        img {
            width: 29px;
            height: 29px;
        }
    }

    .realname {
        text-align: center;
        font-family: PingFang-SC-Medium;
        font-size: 16px;
        line-height: 16px;
        color: #333333;
        margin-top: 10px;
    }

    .alipy {
        text-align: center;
        font-family: PingFang-SC-Regular;
        font-size: 12px;
        line-height: 16px;
        color: #666666;
        margin-top: 12px;
        padding: 0 19px;
    }
}
.normal{
    margin-top:20px;
    .notice{
        width:100%;
        background-color:#fafafa;
        height:49px;
        .normal-left{
            padding-left:15px;
            .notice-first{
                width:70px;
                height:30px;
                background-color:#f3f3f3;
                border-radius:15px;
                text-align:center;
                line-height:30px;
                margin-top:10px;
                .van-icon{
                    margin-right:6px;
                }
            }
        }
        .normal-right{
            line-height:49px;
        }
    }
}
</style>
